import {useRouteNode} from 'react-router5';
import {useState} from "react";
import './style/postListIitem.css';
import {addComment, getPost, updateComment, deleteComment} from "../api";
import {PostItem} from "./postItem";
import {PostCommentInput} from "./postCommentInput";
import {CommentList} from "./commentList";

const Post = () => {

    const { route: {data} } = useRouteNode('post');
    const [post_state] = useState(data.post);

    const [displayModal,setDisplayModal] = useState(false);
    const [searchUser,setSearchUser] = useState(false);
    const [mentions,setMentions] = useState([]);
    const [comments,setComments] = useState(post_state.comments);

    function comment(event){
        const start =event.target.selectionStart;
        const commentSliceLastEdit = event.target.value.slice(0,start);
        const commentSliceSplit = commentSliceLastEdit.split(' ');
        const commentSliceLastWord = commentSliceSplit[commentSliceSplit.length-1];
        const commentLastWordTab = event.target.value.split(" ").filter((content)=>content.includes(commentSliceLastWord));
        const commentLastWord = commentLastWordTab[commentLastWordTab.length - 1];
        const isMention = commentSliceLastWord.includes('@');

        setSearchUser(commentLastWord.slice(1));

        if(isMention){
            setDisplayModal(true);
        }else{
            setDisplayModal(false);
        }
    }

    const addMention =(user)=>{
        const mentionsTab = mentions;
        mentionsTab.push({type:'mention',content:'@'+user.firstname.replace(' ',''),user_id:user.id});
        setMentions(mentionsTab);
    }

    function formatComment(text){
        let commentText = text.trim();

        let commentObj = {
            post_comment:{
                post_id:data.post.id,
                body:[]
            }};
        let commentTab = commentText.split(' ');
        let contentText = "";
        commentTab.forEach((word,index)=>{
            if (word.startsWith('@')){
                if(index!==0){
                    commentObj.post_comment.body.push({type:"text",content:contentText});
                }
                contentText="";
                let mention = mentions.filter(item=>item.content===word)[0];
                if(mention!=null){
                    commentObj.post_comment.body.push(mention);
                }else{
                    commentObj.post_comment.body.push({type:"text",content:word});
                }
            }else{
                contentText += word + " ";
            }
        });
        if(contentText!==""){
            commentObj.post_comment.body.push({type:"text",content:contentText.trim()});
        }
        return commentObj;
    }


    const reloadComments = () => {
      const id = post_state.id;
      return getPost(id).then(data2=>{
          setDisplayModal(false);
          setComments(data2.comments);
          setMentions([]);
      });
    }


    // check id or not
    const submitComment = (text) =>{
        const comment = formatComment(text);
        if (comment.post_comment.body.length===0){
            return null;
        }

        addComment(comment)
        .then(reloadComments)
        .then(() => {
          mentionConverseJs(comment.post_comment);
        })
    }


    const mentionConverseJs = (comment) =>{
        comment.body.forEach((item)=>{
            if(item.type === 'mention'){
                const id = post_state.id;
                window._converse.reticular.mention(item.user_id, id);
            }
        });
    }

    const onDeleteComment = (comment) => {
      if (window.confirm("Ce commentaire va être supprimé, confirmer ?")) {
        deleteComment(comment.id).then(reloadComments)
      }
    }

    const onEditComment = (comment) => {
      // disabled for now (too complex)
      false && updateComment(
        comment.id,
        {body: [{type: "text", content: "EDITED COMMENT"}]}
      ).then(reloadComments)
    }

    // target users for sharing/commenting post
    const target_users =
      data.users.filter((user) => {
	// if the post is confidential, only enable target confidential users
	return user.is_active && (post_state.confidential ? user.has_confidential_access : true)
      });

    return <div className={"postParentContainer"}>
        <div className={'left-70'}>
            <PostItem  users={target_users} post={data.post} />
        </div>
        <div className={"commentsContainer"}>
            <PostCommentInput users={target_users}  submitComment={submitComment} addMentions={addMention}
                              displayModal={displayModal} setDisplayModal={setDisplayModal} search={searchUser} handleChange={comment} />
            <CommentList comments={comments} deleteComment={onDeleteComment} editComment={onEditComment} />

        </div>
    </div>
}

export default Post ;
